
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[id]/merch",
      function () {
        return require("private-next-pages/[id]/merch/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[id]/merch"])
      });
    }
  